import { useState } from 'react';
import { supabasePortal as supabase } from '../lib/supabase';

export default function PortalSelfRegisterPage({ onRegisterSuccess }) {
  const [taz, setTaz] = useState('');
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState(null);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);

  const handleInit = async (e) => {
    e.preventDefault();
    if (!taz || !email) return setError('אנא הזן תעודת זהות ואימייל');
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/portal/self-register-init', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ taz, email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'שגיאה כללית');
      setToken(data.token);
      setStep(2);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!otp || !password) return setError('אנא הזן קוד אבטחה וסיסמה חדשה');
    if (password.length < 6) return setError('סיסמה חייבת לכלול לפחות 6 תווים');
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/portal/self-register-verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, otp, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'שגיאה כללית');
      
      const { data: signInData, error: signInErr } = await supabase.auth.signInWithPassword({
        email: data.email,
        password,
      });
      if (signInErr) throw new Error(signInErr.message);
      
      if (onRegisterSuccess) onRegisterSuccess(signInData.session);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f8fafc', padding: 20, direction: 'rtl', fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{
        background: 'white', padding: 40, borderRadius: 16, boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        width: '100%', maxWidth: 400
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🛡️</div>
          <h1 style={{ margin: 0, fontSize: 24, color: '#1e293b' }}>הרשמה לפורטל</h1>
          <p style={{ color: '#64748b', fontSize: 14, marginTop: 8 }}>
            {step === 1 ? 'הזן את פרטיך כדי לאמת את זהותך.' : 'הזן את הקוד שקיבלת במייל וקבע סיסמה.'}
          </p>
        </div>

        {error && (
          <div style={{ background: '#fef2f2', color: '#991b1b', padding: '12px 16px', borderRadius: 8, fontSize: 14, marginBottom: 20 }}>
            {error}
          </div>
        )}

        {step === 1 ? (
          <form onSubmit={handleInit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>תעודת זהות</label>
              <input
                type="text"
                value={taz}
                onChange={e => setTaz(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 15, boxSizing: 'border-box' }}
                placeholder="לדוגמה: 012345678"
                required
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>כתובת אימייל</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 15, boxSizing: 'border-box' }}
                placeholder="האימייל השמור אצל היועץ"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: 12, borderRadius: 8, border: 'none', background: '#3b82f6', color: 'white',
                fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'מאמת...' : 'המשך'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <a href="/portal" style={{ color: '#3b82f6', fontSize: 14, textDecoration: 'none' }}>חזור להתחברות</a>
            </div>
          </form>
        ) : (
          <form onSubmit={handleVerify}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>קוד אימות (6 ספרות)</label>
              <input
                type="text"
                value={otp}
                onChange={e => setOtp(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 15, letterSpacing: 4, textAlign: 'center', boxSizing: 'border-box' }}
                placeholder="123456"
                maxLength={6}
                required
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>קבע סיסמה חדשה</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 15, boxSizing: 'border-box' }}
                placeholder="לפחות 6 תווים"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: 12, borderRadius: 8, border: 'none', background: '#10b981', color: 'white',
                fontSize: 15, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'רושם...' : 'סיים הרשמה'}
            </button>
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <a href="/portal" style={{ color: '#3b82f6', fontSize: 14, textDecoration: 'none' }}>חזור להתחברות</a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
